"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.providerApi = void 0;
var _crmApi = require("@ys/crm-api");
var _config = require("@/api/crm/config");
const providerApi = exports.providerApi = {
  getTableColumnConfig: _config.getConfigOne,
  updateTableColumnConfig: _config.postConfigUpdate,
  upload: async (...args) => (await _crmApi.OssObjectStorageService.postUploadFile(...args)).data.data
};